module.exports = __webpack_public_path__ + "assets/f1afca14f6c77f8b22c8973d6f093b21.svg";